<template>
  <div id="exam">
    <router-view
      v-if="this.$route.path != '/courseContent/Resources/TestPaper'"
    />
    <div style="height:104% ;     position: relative;" v-else>
      <div class="nav-header">
        <li>
          <one-button @click="addtestpaper">
            <span class="iconfont icon-jiahao" />
            {{ $t('translateText.TestPaper.xjsj') }}</one-button
          >
          <one-button @click="receivedelet">
            <span class="iconfont icon-shanchu1" />
            {{ $t('translateText.TestPaper.plsc') }}</one-button
          >
        </li>
        <li style="width: 20%">
          <search
            :placeholder="$t('translateText.Exam.qsrsjm')"
            @search="onSearch"
          />
        </li>
      </div>
      <div class="nav-body" ref="body">
        <test
          :columns="columns"
          :data2="data"
          :edit1="edit"
          :del="delete1"
          :submit="submit1"
          :title="$t('translateText.Exam.qrsc')"
          @scope="del"
          :Show="true"
          @checkAll="checkAll"
          @update="compile"
        ></test>
      </div>
      <s-modal
        :visible="showdeleteroles"
        @cancel="cancelFn"
        @confirm="confirmFn"
      >
        {{ $t('translateText.Exam.qrscm') }}
      </s-modal>
      <div class="nav-footer">
        <pag ref="pag" @passpage="passpage" />
      </div>
    </div>
  </div>
</template>

<script>
import search from '@/components/search' //搜索组件
import pag from '@/components/pagiation' //分页组件
import test from '@/components/Table/Table' //表单组件
import sModal from '@/components/Modal/secondModal' //对话框modal
import {
  getPageExamination,
  deleteExamination,
  getExaminationInfo,
} from '@/utils/api'
export default {
  data() {
    return {
      pageNumber: '1',
      courseid: '',
      trigger: '',
      showdeleteroles: false,
      color: false,
      selectedRowKeys: [],
      current: ['mail'],
      edit: this.$t('translateText.Exam.Edit'),
      delete1: this.$t('translateText.Exam.Delete'),
      submit1: '',
      bodyHeight: 0,
      showuser: [],
      searchKey: '',
      data: [],
    }
  },
  computed: {
    columns() {
      return [
        {
          title:  this.$t('translateText.Exam.xxh'),
          dataIndex: 'serialnumber',
          // width: 80,
        },
        {
          title: this.$t('translateText.Exam.sjmc'),
          dataIndex: 'strExaminationName',
          ellipsis: true,
          width: 560,
        },
        {
          title:this.$t('translateText.Exam.cz'),
          dataIndex: 'op',
          scopedSlots: { customRender: 'op' },
        },
      ]
    },
    selectedRowKey() {
      return this.selectedRowKeys.length > 0
    },
    search() {
      return this.searchKey.length
    },
  },
  mounted() {
    this.courseid = localStorage.getItem('courseId')
    if (this.$route.path == '/courseContent/Resources/TestPaper') {
      this.getexamination()
    }
  },
  methods: {
    passpage(pageNumber) {
      this.pageNumber = pageNumber
      this.getexamination()
    },
    getexamination() {
      getPageExamination({
        iCourseId: this.courseid,
        iExaminationType: 0,
        strExaminationName: this.searchKey,
        iCurPage: this.pageNumber,
        iPageSize: 10,
      }).then((response) => {
        if (response.data.iCode == 0) {
          response.data.objData.listPage.forEach((item, index) => {
            this.$refs.pag.showTotal = response.data.objData.iTotalPages * 10
            this.$refs.pag.pageNumber = response.data.objData.iPageIndex
            sessionStorage.setItem(
              'showTotal',
              response.data.objData.iTotalPages * 10
            )
            sessionStorage.setItem(
              'pageNumber',
              response.data.objData.iPageIndex
            )
            this.$set(item, 'serialnumber', index + 1)
            this.$set(item, 'key', item.iExaminationId)
          })
          this.data = response.data.objData.listPage
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    deleteexamination() {
      let arr2 = this.selectedRowKeys.map((item) => {
        return Object.assign({}, { iExaminationId: item })
      })
      deleteExamination(arr2).then((response) => {
        var pageNum = this.$refs.pag.showTotal / 10
        if (pageNum == this.pageNumber && this.data.length == arr2.length) {
          this.pageNumber--
          if (this.pageNumber == 0) {
            this.pageNumber = 1
          }
        }
        if (response.data.iCode == 0) {
          this.getexamination()
        } else if(response.data.iCode == 1000){
          return this.$message.error(this.$t('translateText.Exam.sjbsy'))
        } else {
          return this.$message.error(response.data.strMessage)
        }
      })
    },
    compile(row) {
      getExaminationInfo({
        iExaminationId: row.iExaminationId,
      }).then((response) => {
        // this.$store.getexaminationinfo(response.data.objData.listQuestion)
        this.$store.commit('getexaminationinfo', response.data.objData)
        this.$router.push({
          path: '/courseContent/Resources/TestPaper/UpdateTestPaper',
          query: {
            examinationType: '0',
          },
        })
      })
    },
    //全选
    checkAll(val) {
      this.selectedRowKeys = val
    },
    cancelFn() {
      this.showdeleteroles = false
    },
    confirmFn() {
      this.showdeleteroles = false
      this.deleteexamination()
    },
    delFn() {
      this.showdeleteroles = true
      // this.color = true;
    },
    receivedelet() {
      if (this.selectedRowKey) {
        this.showdeleteroles = true
        this.color = true
        return false
      }
      return this.$message.error(this.$t('translateText.Exam.qdwxz'))
    },
    del(item) {
      this.selectedRowKeys = [item.iExaminationId]
      this.deleteexamination()
    },
    addtestpaper() {
      this.$router.push({
        path: '/courseContent/Resources/TestPaper/NewTestPaper',
        query: {
          examinationType: '0',
        },
      })
    },
    //搜索试卷
    onSearch(val) {
      //搜索按钮的回调事件
      // this.searchuser(val);
      this.searchKey = val
      this.pageNumber = 1
      this.getexamination()
    },
  },
  components: {
    search,
    pag,
    sModal,
    test,
  },
}
</script>

<style lang="less" scoped>
/deep/.ant-table-tbody > tr > td {
  padding: 9.5px 13px;
}
#exam {
  height: 100%;
  width: 100%;
  padding: 0 3% 0 2%;
  .nav-header {
    right: 2%;
    left: 2%;
    height: 10%;
    position: absolute;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #d5d5d5;
    margin-bottom: 1%;
  }
  .nav-body {
    position: absolute;
    top: 10%;
    right: 2%;
    left: 2%;
    // bottom: 6%;
    bottom: 48px;
    overflow: auto;
  }
  .nav-body::-webkit-scrollbar {
    display: none;
  }
}
</style>
